import { useContext } from 'react';
import { FormContext } from '../context';

export default () => useContext(FormContext);
